export default __webpack_public_path__ + "static/media/diamond_dark.25614efd.svg";